import styled from 'styled-components'
import theme from 'theme_'
import { Icon } from '@mdi/react'

export const PlanIcon = styled.img<{ size?: number }>`
  color: ${theme.colors.otterWarmBlack};
  width: ${(p) => (p.size ? `${p.size}px` : '28px')};
  height: ${(p) => (p.size ? `${p.size}px` : '28px')};
  margin-right: 8px;
`

export const UserIcon = styled.img<{ size?: number }>`
  color: ${theme.colors.otterWarmBlack};
  width: ${(p) => (p.size ? `${p.size}px` : '32px')};
  height: ${(p) => (p.size ? `${p.size}px` : '32px')};
  margin-right: 8px;
`

export const StyledPlanIcon = styled(Icon)`
  color: ${theme.colors.otterWarmBlack};
  width: ${(p) => (p.size ? `${p.size}px` : '28px')};
  height: ${(p) => (p.size ? `${p.size}px` : '28px')};
  margin-right: 8px;
`
